import { CheckboxFilter, type Option } from '@lifebit-ai/lds'
import React from 'react'

import { useGetLabelsFromExportRequests } from 'services/results/hooks/useGetLabelsFromExportRequests'

interface LabelsFilterProps {
  onApply: (filteredOptions: Option[]) => void
  onReset: () => void
}

export const LabelsFilter: React.FC<LabelsFilterProps> = ({ onApply, onReset }) => {
  const getLabelsQuery = useGetLabelsFromExportRequests()

  const options: Option[] =
    getLabelsQuery.data?.data.map(label => ({
      label: label.name,
      value: label._id
    })) ?? []

  return (
    <CheckboxFilter
      label="Labels"
      loading={getLabelsQuery.isLoading}
      onApply={onApply}
      options={options}
      onReset={onReset}
      searchFieldPlaceholder="Search labels"
    />
  )
}
